import { render, staticRenderFns } from "./infoSecretQuestionPage.vue?vue&type=template&id=306483da&scoped=true&"
import script from "./infoSecretQuestionPage.vue?vue&type=script&lang=js&"
export * from "./infoSecretQuestionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306483da",
  null
  
)

export default component.exports